import blogData from '../content/blog/posts.json';

export interface BlogPost {
  id: string;
  title: string;
  content: string;
  preview?: string;
  author: string;
  date: string;
}

export const getBlogPosts = (): BlogPost[] => {
  return blogData.posts.sort((a, b) => 
    new Date(b.date).getTime() - new Date(a.date).getTime()
  );
};

export const getBlogPost = (id: string): BlogPost | null => {
  const post = blogData.posts.find(post => post.id === id);
  if (!post) return null;
  return post;
}; 